import { Component, OnInit } from '@angular/core';
import { LoginService } from "./shared/login.service";
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public username: string;
  public password: string;
  login: boolean = false;
  userData: any;
  isAdmin: string = '';


  constructor(
    private loginservice: LoginService,
    private router: Router,

  ) { }
  ngOnInit(): void {


    this.loginservice.loginevent.subscribe(
      (loginstatus: boolean) => {
        this.login = loginstatus
      });
    this.loginservice.getLoginStatus();
    if (this.login) {
      this.userData = this.loginservice.getUserdata(true);
      if (localStorage.getItem('isAdmin') == 'true') {
        this.router.navigate(['/sadmin/dashboard']);
      } else {
        this.router.navigate(['/customer/dashboard']);
      }
    }
  }

  onLogin() {
    var data = { "username": this.username, "password": this.password }
    console.log(data, "yesssssss")
    this.loginservice.doLogin(data).subscribe(
      (datas: any) => {
        if (datas["status"] == "1") {
          this.loginservice.setUserdata(datas);
          this.loginservice.setLoginStatus(1)
          this.login = true;
          this.userData = this.loginservice.getUserdata(true);
          localStorage.setItem('user_name', datas.name)
          localStorage.setItem('token', datas.token)
          localStorage.setItem('customerId', datas.user_id)
          if (datas['type'] == "superadmin") {
            localStorage.setItem('isAdmin', 'true');
            this.router.navigate(['/sadmin/dashboard']);
          } else {
            localStorage.setItem('isAdmin', 'false');
            this.router.navigate(['/customer/dashboard']);
          }

        } else {
          Swal.fire('Oops...', 'Username Or Password Mismatch!', 'error')
        }
      }
    )
  }



}

